import dev from './environment.dev';
import production from './environment.prod';

declare const APP_ENV: string;

export interface SignEnvironment {
  domain: string;
}

const getEnvironment = (appEnv: string | null): SignEnvironment => {
  switch (appEnv) {
    case 'production': return production;
    default: return dev;
  }
};

const environment = getEnvironment(APP_ENV || null);

export default environment;
